export default "__VITE_IMAGE_ASSET__78572d62__";